import {
    Box,
    Text,
    VStack,
    HStack,
    Separator,
} from "@chakra-ui/react";

import {
    Phone,
    Mail,
    Globe,
} from "lucide-react";

const Footer = () => {
    return (
        <Box
            mt={10}
            pt={6}
            borderTop="1px solid"
            borderColor="gray.200"
        >
            <VStack
                gap={4}
                align="center"
            >
                <Text
                    fontSize="sm"
                    color="gray.500"
                    lineHeight="1.8"
                    textAlign="center"
                    maxW="700px"
                >
                    Need additional help with
                    recruits, payouts,
                    commissions, or your
                    Partner account?
                    Our support team is
                    available to assist you.
                </Text>

                <HStack
                    gap={12}
                    flexWrap="wrap"
                    justify="center"
                >
                    <VStack gap={2}>
                        <Phone
                            size={18}
                            color="#2453FF"
                        />

                        <Text
                            fontSize="xs"
                            color="gray.500"
                            textTransform="uppercase"
                            fontWeight="700"
                        >
                            Phone
                        </Text>

                        <Text
                            fontWeight="600"
                            color="#071D54"
                            textAlign="center"
                        >
                            +267 7601 9336
                        </Text>
                    </VStack>

                    <VStack gap={2}>
                        <Mail
                            size={18}
                            color="#2453FF"
                        />

                        <Text
                            fontSize="xs"
                            color="gray.500"
                            textTransform="uppercase"
                            fontWeight="700"
                        >
                            Support Email
                        </Text>

                        <Text
                            fontWeight="600"
                            color="#071D54"
                            textAlign="center"
                        >
                            mogoma@aigenix.co.bw
                        </Text>
                    </VStack>

                    <VStack gap={2}>
                        <Globe
                            size={18}
                            color="#2453FF"
                        />

                        <Text
                            fontSize="xs"
                            color="gray.500"
                            textTransform="uppercase"
                            fontWeight="700"
                        >
                            Website
                        </Text>

                        <Text
                            fontWeight="600"
                            color="#071D54"
                            textAlign="center"
                        >
                            aigenix.co.bw/mogoma
                        </Text>
                    </VStack>
                </HStack>

                <Separator />

                <Text
                    fontSize="xs"
                    color="gray.500"
                    textAlign="center"
                >
                    © {new Date().getFullYear()}{" "}
                    Mogoma Partner
                    Portal. Powered by
                    AiGeniX.
                </Text>
            </VStack>
        </Box>
    );
};

export default Footer;